const escapeHtml = (value: string): string =>
  value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

/** Wraps email body HTML in the same shell the mailers send to clients (maroon footer with reply-to). */
export const buildEmailPreviewHtml = (body: string, senderDisplayName: string, replyToEmail: string): string => {
  const sender = escapeHtml(senderDisplayName);
  const replyTo = escapeHtml(replyToEmail);
  return `
<!DOCTYPE html>
<html>
  <head>
    <meta charset="UTF-8">
    <style>body { font-family: Arial, Helvetica, sans-serif; margin: 0; padding: 0; background-color: #f4f4f4; }</style>
  </head>
  <body>
    <table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="background-color:#f4f4f4;">
      <tr>
        <td align="center" style="padding:24px 16px;">
          <table role="presentation" width="600" cellpadding="0" cellspacing="0"
                 style="max-width:600px;background:#fff;border-radius:8px;overflow:hidden;box-shadow:0 2px 8px rgba(0,0,0,0.08);">
            <tr><td style="padding:0 40px;"><hr style="border:none;border-top:2px solid #96052F;margin:0;" /></td></tr>
            <tr>
              <td style="padding:32px 40px;color:#333;font-size:15px;line-height:1.7;font-family:Arial,Helvetica,sans-serif;">
                ${body}
              </td>
            </tr>
            <tr>
              <td style="background:#96052F;padding:20px 40px;text-align:center;">
                <p style="margin:0;color:#fff;font-size:13px;font-family:Arial,Helvetica,sans-serif;">
                  ${sender} &bull; <a href="mailto:${replyTo}" style="color:#fff;text-decoration:underline;">${replyTo}</a>
                </p>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  </body>
</html>
`;
};
